import routerBase from "@nextories/vue-tasks/src/router";
import { createRouter, createWebHistory } from "vue-router";

const AppRoutes = {
  Home: () => import('@nextories/vue-tasks/src/views/NxtTasksViewHome.vue'),
  Project: () => import('@nextories/vue-tasks/src/views/NxtTasksViewProject.vue'),
  Sav: () => import('@/views/Sav.vue'),
  FurnitureStorage: () => import('@/views/FurnitureStorage.vue'),
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routerBase.routes().concat([
    {
      path: '/',
      name: 'home',
      component: AppRoutes.Home,
      meta: {
        layout: 'nxt-tasks-full-layout',
        authRequired: true,
        checkRefreshCounters: true,
      },
      beforeEnter: routerBase.isLogged,
    },
    {
      path: '/sav',
      name: 'sav',
      component: AppRoutes.Sav,
      meta: {
        layout: 'nxt-tasks-full-layout',
        authRequired: true,
        hideSidebar: true,
      },
      beforeEnter: routerBase.isLogged,
    },
    {
      path: '/storage',
      name: 'furnitureStorage',
      component: AppRoutes.FurnitureStorage,
      meta: {
        layout: 'nxt-tasks-full-layout',
        authRequired: true,
        hideSidebar: true,
      },
      beforeEnter: routerBase.isLogged,
    },
    {
      path: '/projects/:id',
      name: 'project',
      component: AppRoutes.Project,
      meta: {
        layout: 'nxt-tasks-full-layout',
        authRequired: true,
        displayExpandRightSidebar: true,
        checkRefreshCounters: true,
      },
      beforeEnter: routerBase.isLogged,
    },
  ]),
});

export default router;
